<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .page-bg{
        background: rgba(255,255,255,.9);
        z-index: 88;
    }
    .page-content{
        background: none;
        z-index: 89;
    }
    .page-bg, .page-content{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transition: all .4s ease-out 0s;
        -moz-transition: all .4s ease-out 0s;
        -webkit-transition: all .4s ease-out 0s;
        -o-transition: all .4s ease-out 0s;
    }
    .page-bg.left, .page-content.left{
        left: -100%;
    }

    .page-bg.top, .page-content.top{
        top: -100%;
    }

    .page-bg.right, .page-content.right{
        left: 100%;
    }

    .page-bg.bottom, .page-content.bottom{
        left: -100%;
    }
    .page-content.left.all,.page-content.top.all,.page-content.right.all,.page-content.bottom.all, .page-bg.left.all,.page-bg.top.all,.page-bg.right.all,.page-bg.bottom.all{
        left: 0;
        top:0;
    }
</style>
<template>
    <section class="page-bg" :class="classes + (status?' all':'')" v-html="html" @click.self="toCancel">
    </section>
</template>

<script>
    export default {
        name: '',
        data() {
            return {
                html:''
            }
        },
        props: ['code','classes','status','content','binds'],
        methods: {
            toCancel: function(){
                this.binds = ''
                this.$parent.$emit('cancel'+this.code);
            },
        },
        components: {},
        mounted() {
            this.$nextTick(function() {
            })
        },
        created() {
            let _this = this,params = []
            let parent = _this.$parent,events = parent[_this.events],code = _this.code
            parent.$on('cancel'+code,(w) => {
                parent.toasts[code] = false;
                params = (events&&events.cancelParam?[events.cancelParam].concat(w):w)
                if(events && events.cancel && _this._checkFun(parent[events.cancel]))
                    parent[events.cancel].apply(this,[params])
            })
        }
    }
</script>


// WEBPACK FOOTER //
// pages.vue?9119418a